import { getEnv } from "@/config/config"
import { alertErrorTwoButton } from "@/Utlis/alerts/aplication/alertErrorTwoButton"
import { AlertRepository } from "@/Utlis/alerts/infraestructure/AlertRepository"
import axios from "axios"

export function ConnectionRepository() {
    return {
        get,
        getOther,
        post,
        put,
        del
    }
}

const headers = () => {
    return {
        'Content-Type': 'application/json',
        'language-iso': 'es',
        'token': getEnv('VUE_APP_TOKEN') ?? ""
    }
}

const server = getEnv('VUE_APP_SERVER_URL') ?? ""

async function get(url) {
    try {
        const response = await axios.get(`${server}${url}`, { headers: headers() })
        return response.data
    } catch (error) {
        console.error(error)
        return null
    }
}

async function getOther(url, header = {}) {
    try {
        const response = await axios.get(`${url}`, {headers: header})
        return response.data
    } catch (error) {
        console.error(error)
        return null
    }
}

async function post(url, body) {
     const response = await axios.post(`${server}${url}`, body, { headers: headers() })
     .then((res) => {
         return res.data
     })
     .catch((error) => {
        alertErrorTwoButton(AlertRepository(), error.response.data.error.message)
        return null
     })
     return response
}

async function put(url, body) {
    try {
        const response = await axios.put(`${server}${url}`, body, { headers: headers() })
        return response.data
    } catch (error) {
        console.error(error)
        return null
    }
}

async function del(url) {
    try {
        const response = await axios.delete(`${server}${url}`, { headers: headers() })
        return response.data
    } catch (error) {
        console.error(error)
        return null
    }
}